import { iFBCallLog } from "@sdk/fb-call-logs/fb-call-logs-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { FBCallLogsDefaultQueryConfig } from "./fb-call-logs-default-query";

export const {
  slice: FBCallLogsSlice,
  reducers: FBCallLogsSliceReducer,
  actions: {
    setEntityQueryResults: setFBCallLogsQueryResults,
    setEntity: setFBCallLog,
    setEntities: setFBCallLogs,
    patchEntity: patchFBCallLog,
    addNewEntity: addNewFBCallLog,
    setEntityFetchingStatus: setFBCallLogFetchingStatus,
    setEntitiesFetchingStatus: setFBCallLogsFetchingStatus,
    setEntityFailedStatus: setFBCallLogFailedStatus,
    setEntityQueryError: setFBCallLogsQueryError,
    resetQuery: resetFBCallLogsQuery,
    setQueryList: setFBCallLogQueryList,
  },
} = CreateEntitySlice<iFBCallLog>({
  sliceName: "FBCallLogs",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...FBCallLogsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
